import { forwardRef } from 'react';
import { Root, Title, Description, Close } from '@radix-ui/react-toast';
import { Icon, Icons } from '../symbols';
import { cn } from '../../utils';
import styles from './toast.module.css';
import { ToastMessage } from './toast.provider';

export type ToastProps = ToastMessage & {
  dismissable?: boolean;
  remove?: (open: boolean) => void;
  open?: boolean;
};

export const Toast = forwardRef<HTMLLIElement, ToastProps>(
  (
    {
      title,
      message,
      dismissable = true,
      duration = 10000,
      variant = 'info',
      type,
      icon = getDefaultIcon(variant),
      open = true,
      remove,
    }: ToastProps,
    ref,
  ) => {
    return (
      <Root
        duration={duration}
        open={open}
        onOpenChange={remove}
        type={type}
        className={cn(
          styles.container,
          variant === 'success' && styles.success,
          variant === 'error' && styles.error,
        )}
        ref={ref}
      >
        <Title className={styles.title}>
          <Icon name={icon} /> {title}
        </Title>
        {message && <Description>{message}</Description>}

        {dismissable && (
          <Close className={styles.close}>
            <Icon name="cross" aria-label="Close" />
          </Close>
        )}
      </Root>
    );
  },
);

function getDefaultIcon(variant: ToastProps['variant']): Icons {
  switch (variant) {
    case 'success':
      return 'checkmark-circle';
    case 'error':
      return 'error';
    default:
      return 'info-circle';
  }
}
